import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-coral/25" data-id="element-0" data-mp="23ut9lxqjzq85">
      <MetaPixel data-id="element-1" data-mp="3ihv22ef0kliv" />
      <TopBar data-id="element-2" data-mp="3mlj9mx3nbh44" />
      <main data-id="element-3" data-mp="3mlat8v8bdto6">
        <HeroSection data-id="element-4" data-mp="3mkrefndynled" />
        <StatsBar data-id="element-5" data-mp="3mk84otygs3bf" />
        <TransformationSection data-id="element-6" data-mp="3mjpyb4i388ps" />
        <PainPointsSection data-id="element-7" data-mp="3rcj6y3gog175" />
        <KitContentsSection data-id="element-8" data-mp="3rdapodp6e4g0" />
        <InstantAccessSection data-id="element-9" data-mp="3rd1a7k1rbfok" />
        <BonusesSection data-id="element-10" data-mp="5yhupa6n3cr" />
        <PricingSection data-id="element-11" data-mp="67yvnd9206b" />
        <GuaranteeSection data-id="element-12" data-mp="5gez9t0lqvv" />
        <TestimonialsSection data-id="element-13" data-mp="82ohezguggq" />
        <FAQSection data-id="element-14" data-mp="2zllff2q1qmn9" />
        <FinalCTASection data-id="element-15" data-mp="2zm4wkh7vh708" />
      </main>
      <Footer data-id="element-16" data-mp="2zn6biws0edn8" />
    </div>;
}